import { useEffect } from "react"

// Displays a warning when the user tries to leave the page if `shouldWarn` is true.
const useLeaveDetection = (shouldWarn: boolean) => {
  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (shouldWarn) {
        event.preventDefault()
        // Modern browsers show a generic message, but this is needed for older ones.
        event.returnValue = ""
      }
    }

    window.addEventListener("beforeunload", handleBeforeUnload)

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload)
    }
  }, [shouldWarn])
}

export default useLeaveDetection
